import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  container: {
    display: "flex",
    minWidth: "400px",
    padding: "24px 32px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
    borderRadius: "0 12px 12px 12px",
    border: `1px solid ${theme.palette.border.secondary}`,
    background: theme.palette.background.paper,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "28px",
  },
  textBtn: {
    color: theme.palette.button.tertiaryGray_fg,
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
  },
  imagesContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    width: "100%",
  },
  cardStyle: {
    padding: "12px",
    width: "261px",
    height: "264px",
    borderRadius: "20px",
    border: `1px solid ${theme.palette.border.secondary}`,
    background: theme.palette.utility.utility_gray_50,
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
  },
  imageBox: {
    width: "100%",
    height: "200px",
    borderRadius: "20px",
    objectFit: "cover",
    backgroundColor: theme.palette.background.paper,
  },
  imageFallback: {
    width: "100%",
    height: "200px",
    borderRadius: "20px",
    backgroundColor: theme.palette.background.secondary_hover,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  detailsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  detailsText: {
    color: theme.palette.text.tertiary,
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
  },
}));
